import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleTagManager } from '/builds/pro/webshop/frontend/node_modules/@nuxt/scripts/dist/runtime/registry/google-tag-manager.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-MWRW4DGH","debug":false,"scriptInput":{"src":"https://sst.prontowonen.nl/gtm.js?id=GTM-MWRW4DGH","crossorigin":false},"scriptOptions":{"bundle":false,"trigger":"onNuxtReady"}})
    return { provide: { scripts: { googleTagManager } } }
  }
})